
























import MessageSpecComponent from "@/modules/cbc/components/form/messageSpec/MessageSpec.vue";
import {
	ConstituentEntity,
	Message,
	ReportData,
	ReportDataGenerateRequest,
	ReportDataUpdateMessageRequest
} from "@/modules/cbc/models";
import {Component, Vue, Watch} from "vue-property-decorator";

@Component({
	components: {
		MessageSpecComponent
	},
	mounted() {
		this.$store.dispatch("cbc/get_message", this.$route.params["id"]);
	}
})
export default class ReportDataMessageView extends Vue {
	public get message(): Message {
		return this.$store.state.cbc.entity.message as Message;
	}

	public set message(message: Message) {
		this.$store.dispatch("cbc/update_message", {
			message: message,
			reportDataId: this.$route.params["id"]
		} as ReportDataUpdateMessageRequest);
	}

	@Watch("message", {deep: true})
	public onChanged(value: Message, oldValue: Message) {
		this.message = value;
	}

	public onGenerate() {
		this.$store.dispatch("cbc/get", this.$route.params["id"]).then(() => {
			this.$store.dispatch("cbc/generate", {
				data: this.$store.state.cbc.entity as ReportData
			} as ReportDataGenerateRequest);
		});
	}
}
